import { Button, Kbd, Box, HStack, Text } from '@chakra-ui/react';
import { useATisActive, useATSelection } from '../hooks';

export const ATActionBar = <T extends Record<string, any>>({
  onActionBarConfirm,
  ActionBarButtonComponent,
}: {
  onActionBarConfirm?: (selection: T[]) => Promise<void> | void;
  ActionBarButtonComponent?: React.ReactNode;
}) => {
  const { selection } = useATSelection();
  const { isActive, setIsActive } = useATisActive();

  return (
    <Box
      position="relative"
      bottom="0"
      left="0"
      right="0"
      bg="transparent"
      py={2}
      borderTop="1px solid"
      borderColor="accent1.solid"
      visibility={isActive ? 'visible' : 'hidden'}
    >
      <HStack
        alignItems="center"
        justifyContent="center"
        color="accent1.fg"
        gap={4}
      >
        <Text fontSize="sm">{selection.size} selected</Text>
        {ActionBarButtonComponent && ActionBarButtonComponent}
        {onActionBarConfirm && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => onActionBarConfirm(selection.get())}
            borderColor="accent1.solid"
            _hover={{
              bg: 'tertiary.bg',
            }}
          >
            Confirm <Kbd>↵</Kbd>
          </Button>
        )}
      </HStack>
    </Box>
  );
};
